'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id) {
  var stats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var skipCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var status = arguments[3];
  return function (dispatch, getState) {
    var events = (0, _paths.getEvents)(getState(), feis_id);

    // prefer the cached version
    if (!skipCache && events) return Promise.resolve();

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id),
        params: {
          stats: stats,
          status: status
        }
      },
      types: ['GET_EVENTS_START', 'GET_EVENTS', 'GET_EVENTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getEvents.js
// module id = 103
// module chunks = 0